import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'User Roles',
  basePath: '/users-roles',
  columns: [
    { key: 'role', label: 'Role', sortable: true },
    { key: 'menu_names', label: 'Access', sortable: false },
  ],
  fields: [
    { key: 'role', label: 'Role', type: 'text', required: true },
    { key: 'menu', label: 'Access', type: 'multi-relation',
      engine: 'searchable-multi', optionsUrl: '/menu/options' },
  ],
  defaultSort: { field: 'role', dir: 'asc' },
});
